import HtmlCreativeImportTransformer from '@/components/domain/creatives/html/bulk/HtmlCreativeImportTransformer';
import ExcelCreativeExtractor from '@/shared/excel/ExcelCreativeExtractor';
import IRawHtmlExcelRow from '@/components/domain/creatives/html/bulk/IRawHtmlExcelRow';
import IBulkHtmlCreativeRow from '@/components/domain/creatives/html/bulk/IBulkHtmlCreativeRow';

export default function createHtmlExcelCreativeExtractor(): ExcelCreativeExtractor<IRawHtmlExcelRow, IBulkHtmlCreativeRow> {
    const htmlCreativeTransformer = new HtmlCreativeImportTransformer();
    return ExcelCreativeExtractor.create(htmlCreativeTransformer, ['name', 'size', 'template']);
}
